import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { manage_sub_category } from "../../reduxData/user/userAction";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import CategorySearchDropdown from "./CategorySearchDropdown";
import { useTranslation } from "react-i18next";

const AddSubCategoryModal = ({
  open,
  onClose,
  onSaved,
  allCategories,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [subName, setSubName] = useState("");
  const [subName_nl, setSubName_nl] = useState("");
  const [selectedCatId, setSelectedCatId] = useState("");

  const [errors, setErrors] = useState({
    subName: "",
    subName_nl: "",
    category: "",
  });

  const bodyRef = useRef(null);

  useEffect(() => {
    if (!open) {
      setSubName("");
      setSubName_nl("");
      setSelectedCatId("");
      setErrors({
        subName: "",
        subName_nl: "",
        category: "",
      });
    }
  }, [open]);

  // handle category dropdown 
  const handleDropdownOpen = () => {
    setTimeout(() => {
      if (bodyRef.current) {
        bodyRef.current.scrollTo({
          top: bodyRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    }, 200);
  };

  // handle subcategory name 
  const handleSubNameChange = (e) => {
    const value = e.target.value;
    setSubName(value);
    setErrors((prev) => ({
      ...prev,
      subName: value.trim()
        ? ""
        : t("addSubCategoryModal.subNameRequired"),
    }));
  };

  // hanlde subcategory dutch name 
  const handleSubNameNlChange = (e) => {
    const value = e.target.value;
    setSubName_nl(value);
    setErrors((prev) => ({
      ...prev,
      subName_nl: value.trim()
        ? ""
        : t("addSubCategoryModal.subNameNlRequired"),
    }));
  };

  // handle category selector 
  const handleCategoryChange = (id) => {
    setSelectedCatId(id);
    setErrors((prev) => ({
      ...prev,
      category: id
        ? ""
        : t("addSubCategoryModal.selectCategoryRequired"),
    }));
  };

  // form validations 
  const validate = () => {
    let valid = true;
    const newErrors = {
      subName: "",
      subName_nl: "",
      category: "",
    };

    if (!subName.trim()) {
      newErrors.subName =
        t("addSubCategoryModal.subNameRequired");
      valid = false;
    }

    if (!subName_nl.trim()) {
      newErrors.subName_nl =
        t("addSubCategoryModal.subNameNlRequired");
      valid = false;
    }

    if (!selectedCatId) {
      newErrors.category =
        t("addSubCategoryModal.selectCategoryRequired");
      valid = false;
    }
    setErrors(newErrors);
    return valid;
  };

  // hanlde form submit 
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    const formData = new FormData();
    formData.append("name", subName);
    formData.append("name_nl", subName_nl);
    formData.append("category_id", selectedCatId);
    const data = await manage_sub_category(formData, dispatch, null);
    if (data) {
      onSaved();
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog className="modern-modal">
        <div className="modal-header-custom">
          <div>
            <h3>{t("addSubCategoryModal.title")}</h3>
          </div>
          <button
            className="close-btn"
            onClick={onClose}
          > ✕ </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div
            className="modal-body-custom subcategory-modal-height"
            ref={bodyRef}
          >
            <div className="form-group-modern">
              <label>{t("addSubCategoryModal.selectCategoryLabel")}</label>
              <CategorySearchDropdown
                categories={allCategories}
                value={selectedCatId}
                onChange={handleCategoryChange}
                onOpen={handleDropdownOpen}
                placeholder={t("addSubCategoryModal.selectCategoryPlaceholder")}
              />
              {errors.category && (
                <div className="error_msg">
                  {errors.category}
                </div>
              )}
            </div>
            <div className="form-group-modern">
              <label>{t("addSubCategoryModal.subNameLabel")}</label>
              <input
                className={`modern-input ${errors.subName
                  ? "input-error"
                  : ""
                  }`}
                placeholder={t("addSubCategoryModal.subNamePlaceholder")}
                value={subName}
                onChange={handleSubNameChange}
              />

              {errors.subName && (
                <div className="error_msg">
                  {errors.subName}
                </div>
              )}
            </div>
            <div className="form-group-modern">
              <label>{t("addSubCategoryModal.subNameNlLabel")} </label>
              <input
                className={`modern-input ${errors.subName_nl
                  ? "input-error"
                  : ""
                  }`}
                placeholder={t("addSubCategoryModal.subNameNlPlaceholder")}
                value={subName_nl}
                onChange={handleSubNameNlChange}
              />
              {errors.subName_nl && (
                <div className="error_msg">
                  {errors.subName_nl}
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer-custom">
            <button
              type="button"
              className="secondary-btn"
              onClick={onClose}
            >
             {t("addSubCategoryModal.cancel")}
            </button>

            <button
              type="submit"
              className="primary-btn"
            >
              {t("addSubCategoryModal.save")}
            </button>
          </div>
        </form>
      </ModalDialog>
    </Modal>
  );
};

export default AddSubCategoryModal;

